import React from 'react'
import { Route, Routes } from 'react-router-dom'
import AllUpcoming from '../match/upcoming/AllMatch';
import AllLaunch from '../match/launch/AllMatch';
import UpdateMatch from '../match/upcoming/UpdateMatch'
import UpcomingAllBets from '../match/upcoming/AllBets';
import LunchAllBets from '../match/launch/AllBets';
import ViewBets from '../match/launch/ViewBets';
import AddMatch from '../match/upcoming/AddMatch';
import AllMatch from '../match/live/AllMatch';
import CompletedMatch from '../match/complete/CompletedMatch';
import AbondonedMatch from '../match/abondoned/AbondonedMatch';

function MatchRoutes() {
  return (
    <Routes>
        <Route path="/all-upcoming" element={<AllUpcoming />} />
        <Route path="/add-upcoming-match" element={<AddMatch />} />
        
        <Route path="/all-launch" element={<AllLaunch />} />
        <Route path="/view-bets" element={<ViewBets />} />
        
        <Route path="/update-match" element={<UpdateMatch />} />
        <Route path="/upcoming-bets" element={<UpcomingAllBets />} />
        <Route path="/launch-bets" element={<LunchAllBets />} />

        <Route path="/all-live" element={<AllMatch />} />

        <Route path="/all-completed" element={<CompletedMatch />} />

        <Route path="/all-abondoned" element={<AbondonedMatch />} />
    </Routes>
  )
}

export default MatchRoutes
